// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2u_X8","content":"ManualTimeModal_content__14fe7"};